export default __webpack_public_path__ + "static/media/menu-tile.65d33402.png";